
export const KEY_NAME = 'contract-templates_list'
export const RULE_VALIDATE = {
    name: [
        { required: true, message: '配置名称必填', trigger: 'blur' }
    ],
    content: [
        {
             validator (rule, value, callback) {
                 console.log(value)
            if(value&&value.length>0) {
                callback();
            } else {
                callback(new Error('人员列表必选'));
            }
          },    
          required: true
        },
    ],
}

export const DEFAULT_DATA= {
    desc: '',
    file: {},
    showEdit: true
}

export const DEFAULT_DATA_ALL = {
        name:'',
        key_name: KEY_NAME,
        id: 0,
        content: [
            {
                desc: '',
                name: '',
                showEdit: true,
                loading: false,
                file: {} 
            }
        ]
}